export const apiFetch = (...args) =>
  fetch(...args)
    .then((results) => results.json())
    .catch((e) => {
      console.error('There was an error fetching', e);
      console.error(...args);
    });
